import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CollapseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CollapseSVG;
